<template>
  <form-field
    :id="id"
    :title="title"
    :class="className"
    :show-label="showLabel"
    :error-message="errorMessage"
  >
    <textarea
      v-bind="$attrs"
      :id="id"
      :name="id"
      :value="modelValue"
      :rows="rows"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    />
  </form-field>
</template>

<script>
import FormField from '@/components/generic/presentational/atoms/formField/FormField.vue'

export default {
  components: {
    FormField,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    className: {
      type: String,
      default: '',
    },
    rows: {
      type: String,
      default: '',
    },
  },
  emits: ['change', 'update:modelValue'],
}
</script>

<style lang="scss" scoped>
textarea {
  height: auto;
}
</style>
